export default __webpack_public_path__ + "static/media/16 TOOLS.8f49069b.png";